<h2 mat-dialog-title class="treeslo-modal-header">
    <span class="treeslo-modal-header__title">
        {{ 'modals.onboarding.title' | translate }}
    </span>
    <div class="treeslo-modal-header__actions">
        <button mat-icon-button [matMenuTriggerFor]="languageMenu" class="language-button"
            aria-label="Select language">
            <img [src]="selectedLanguage.icon" [alt]="selectedLanguage.language" />
        </button>
        <mat-menu #languageMenu="matMenu" class="language-menu">
            <button mat-menu-item *ngFor="let lang of languages" (click)="changeLanguage(lang)">
                <img [src]="lang.icon" class="flag-icon" [alt]="lang.language" />
                <span>{{ lang.language }}</span>
            </button>
        </mat-menu>
    </div>
</h2>

<mat-dialog-content>
    @if (momentStep === 'welcomeFirstTimeOnboarding') {
    <app-welcome-first-time-onboarding-body [userName]="userName" [momentStep]="momentStep"></app-welcome-first-time-onboarding-body>
    } @else if (momentStep === 'resumeIncompleteStoreSetup') {
    <app-resume-incomplete-store-setup-body [userName]="userName" [momentStep]="momentStep"
        (continue)="continueResumeIncompleteStoreSetup()"></app-resume-incomplete-store-setup-body>
    }@else if (momentStep === 'afterLinkingStore') {
    <app-store-link-after-linking-body [userName]="userName"
        [momentStep]="momentStep"></app-store-link-after-linking-body>
    } @else if (momentStep === 'afterCompleteDeliveryAndThresholdForm') {
    <app-after-complete-delivery-and-threshold-form-body [userName]="userName" [momentStep]="momentStep"
        (continue)="continueAfterCompleteDeliveryAndThresholdForm()"></app-after-complete-delivery-and-threshold-form-body>
    } @else if (momentStep === 'delegatedWelcome') {
    <app-delegated-welcome-body [userName]="userName"></app-delegated-welcome-body>
    }
</mat-dialog-content>

@if (momentStep === 'welcomeFirstTimeOnboarding') {
<mat-dialog-actions align="end">
    <div class="treeslo-modal-actions">
        <button mat-flat-button color="primary" (click)="onWelcomeFirstTimeOnboarding()">
            {{ 'modals.welcome_first_time_onboarding.startGuidedTour' | translate }}
        </button>
    </div>
</mat-dialog-actions>
} @else if (momentStep === 'afterLinkingStore') {
<mat-dialog-actions align="end">
    <div class="treeslo-modal-actions">
        <button mat-flat-button color="primary" (click)="continueAfterLinkingStore()">
            {{ 'modals.store_link_after_linking.continue' | translate }}
        </button>
    </div>
</mat-dialog-actions>
} @else if (momentStep === 'delegatedWelcome') {
<mat-dialog-actions align="end">
    <div class="treeslo-modal-actions">
        <button mat-flat-button color="primary" (click)="continueDelegatedWelcome()">
            {{ 'modals.delegatedWelcome.completeOnboarding' | translate }}
        </button>
    </div>
</mat-dialog-actions>
}
